<template>
  <v-dialog
      v-if="report"
      v-model="openApprovalHistoryDialog"
      width="600"
      @click:outside="closeHistory"
      style="z-index: 202;"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          light
          class="mr-4"
          v-bind="attrs"
          @click="closeHistory"
      >
        <v-icon>mdi-clipboard-text-clock-outline</v-icon>
        承認履歴
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        承認履歴
      </v-card-title>
      <v-card-text style="max-height: calc(100vh - 250px); overflow-y: scroll;">
        <v-timeline align-top dense>
          <v-timeline-item
              :color="historyColor[history.type].color"
              v-for="history in approval_history.slice().reverse()"
              :key="history.id"
              :icon="historyColor[history.type].icon"
          >
            <v-row>
              <v-col cols class="pa-0">
                <v-alert :type="historyColor[history.type].type"
                         :color="historyColor[history.type].color"
                         class="text-subtitle-2"
                >
                  <div>
                    <strong>{{ history.created_at | formatDate }}</strong>
                  </div>
                  <v-divider class="pt-2 mt-2"></v-divider>
                  <div v-if="!history.type.includes('SUBMITTED')">
                    <div>
                      <span>依頼者：<strong>{{ history.action_sender }}</strong></span>
                    </div>
                    <div>
                      <span>承認者：<strong>{{ history.action_receiver }}</strong><strong>{{ historyColor[history.type].role_text }}</strong></span>
                    </div>
                    <div>
                      <span>種類：{{ historyColor[history.type].category }}</span>
                    </div>
                    <div v-if="!history.type.includes('CANCEL')">
                      <div>コメント：</div>
                      {{ history.comment }}
                    </div>
                    <div v-if="history.type.includes('REJECTED')">
                      <v-divider class="pt-2 mt-2"></v-divider>
                      <strong>{{ history.action_receiver }}（作成者）</strong>へ修正依頼をします。
                    </div>
                  </div>
                  <div v-else>
                    <span v-html="`<strong>${history.action_sender}${historyColor[history.type].role_text}</strong>が顧客に送信しました。`"></span>
                  </div>
                </v-alert>
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
      <v-overlay absolute :value="loading" opacity="1" color="white">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: "ReportConfirmHistory",
  props: ['report', 'folderId'],
  data(){
    return {
      openApprovalHistoryDialog: false,
      historyColor: {
        'BRANCH_REQUESTED': {
          color: 'info',
          role_text: '',
          type: 'info',
          icon: 'mdi-share',
          category: '１次承認依頼'
        },
        'AREA_REQUESTED': {
          color: 'info',
          role_text: '',
          type: 'info',
          icon: 'mdi-share',
          category: '２次承認依頼'
        },
        'SUBMIT_REQUESTED': {
          color: 'info',
          role_text: '',
          type: 'info',
          icon: 'mdi-share',
          category: '営業者承認依頼'
        },
        'BRANCH_REQUEST_REJECTED': {
          color: '#d24150',
          role_text: '',
          type: 'error',
          icon: 'mdi-share-off-outline',
          category: '１次承認却下'
        },
        'AREA_REQUEST_REJECTED': {
          color: '#d24150',
          role_text: '',
          type: 'error',
          icon: 'mdi-share-off-outline',
          category: '２次承認却下'
        },
        'SUBMIT_REJECTED': {
          color: '#d24150',
          role_text: '',
          type: 'error',
          icon: 'mdi-share-off-outline',
          category: '営業承認却下'
        },
        'BRANCH_REQUEST_CANCEL': {
          color: '#9E9E9E',
          role_text: '',
          type: 'error',
          icon: 'mdi-backup-restore',
          category: '１次承認キャンセル'
        },
        'AREA_REQUEST_CANCEL': {
          color: '#9E9E9E',
          role_text: '',
          type: 'error',
          icon: 'mdi-backup-restore',
          category: '２次承認キャンセル'
        },
        'SUBMIT_REQUEST_CANCEL': {
          color: '#9E9E9E',
          role_text: '',
          type: 'error',
          icon: 'mdi-backup-restore',
          category: '営業承認キャンセル'
        },
        'SUBMITTED': {
          color: 'success',
          role_text: '',
          type: 'success',
          icon: 'mdi-email-fast-outline',
          category: ''
        },
      },
      approval_history: [],
      loading: true,
    }
  },
  methods: {
    closeHistory(){
      this.approval_history = [];
      this.openApprovalHistoryDialog = !this.openApprovalHistoryDialog;
    },
  },

  watch: {
    openApprovalHistoryDialog(openApprovalHistoryDialog){
      if (openApprovalHistoryDialog){
        this.loading = true;
        this.axios
            .get('/api/report/approval_history/' + this.folderId)
            .then((response) => {
              this.approval_history = response.data.approval_history;
            })
            .catch(() => {
              store.showErrorDialog('エラーが発生しました。再度試してください。');
            })
            .then(() => {
              this.loading = false;
            });
      }
    }
  }
}
</script>

<style scoped>

</style>
